import { Component, Inject, OnInit } from '@angular/core';

import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { catchError, take, tap } from 'rxjs/operators';

import { GeoidService } from 'src/app/global/components/forms/geoid-address/service/geoid.abstract.service';

@Component({
    selector: 'app-edit-address-dialog',
    templateUrl: './edit-address-dialog.component.html',
    styleUrls: ['./edit-address-dialog.component.scss'],
})
export class EditAddressDialogComponent implements OnInit {
    public hasResults: boolean = false;
    public geoIdAddressForm: FormGroup;
    public geoIdSearchQueryForm: FormGroup;
    public listData = [];
    public listDataForceSearch = [];
    public loading: boolean = false;
    public forceSearchUsed: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<EditAddressDialogComponent>,
        private geoidService: GeoidService,
    ) {}

    get query() {
        return this.geoIdSearchQueryForm.get('query');
    }
    get address() {
        return this.geoIdAddressForm.get('address');
    }

    ngOnInit(): void {
        this.geoIdSearchQueryForm = this.formBuilder.group({
            query: new FormControl('', [Validators.required]),
        });

        this.geoIdAddressForm = this.formBuilder.group(
            {
                address: new FormControl('', [Validators.required]),
            },
            {
                updateOn: 'blur',
            },
        );

        this.address.valueChanges.subscribe((value: any) => {
            if (value) {
                const addressString = `${value.unit} ${value.number} ${value.street}, ${value.city}, ${value.province}, ${value.postCode}`;
                this.query.setValue(addressString);
            }
        });
    }

    querySearch() {
        this.geoIdSearchQueryForm.markAllAsTouched();

        if (this.geoIdSearchQueryForm.valid) {
            this.loading = true;
            this.geoidService
                .searchAddressQuery(this.query.value)
                .pipe(
                    take(1),
                    tap((addresses) => {
                        this.listData = addresses.map((d) => {
                            const unit = d.unit ? d.unit : '';
                            d.unit = unit;
                            return {
                                label: `<i class="icon-map"></i> ${d.unit} ${d.number} ${d.street}, ${d.city}, ${d.province}, ${d.postCode}`,
                                value: d,
                            };
                        });
                    }),
                    tap(() => {
                        this.hasResults = true;
                        this.loading = false;
                    }),
                    catchError((error) => {
                        this.loading = false;
                        // this.contextService.errorMessage(this.translate.instant('common.errors.unknown'));
                        return error;
                    }),
                )
                .subscribe();
        }
    }

    closeDialog() {
        this.dialogRef.close(this.address.value);
    }
}
